var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right-bottom"},[_c('div',{staticClass:"right-top",on:{"click":_vm.goHead}}),_c('div',{staticClass:"right-down",on:{"click":_vm.goPanoBack}})])}
var staticRenderFns = []

export { render, staticRenderFns }